import { dataPolicies, Policy } from '@/core/api/sigma';

export function filterMatchingPolicies(
    data: dataPolicies,
    ccedtitular: string,
    insurerId: string,
    clientId: string,
    planId: string | null | undefined,
    productId: string | null | undefined,
    locatorCode: string,
    benefitId?: string | null
): Policy[] {
    return data.policies.filter(policy => {
        // Verificaciones de identidad
        if (
            policy.holderid !== ccedtitular ||
            policy.insurerid !== insurerId ||
            policy.clientid !== clientId
        ) return false;

        // Verificar por producto (CTYPE="P")
        if (productId) {
            const productExists = policy.products?.some(p => p.id === productId);
            if (!productExists) return false;

            const plansForProduct = policy.plansbyproduct?.find(pp => pp.productid === productId);
            if (!plansForProduct?.plans?.length) return false;

            return plansForProduct.plans.some(plan =>
                (!planId || plan.id === planId) &&
                policy.locatortypesbyplan?.some(ltp =>
                    ltp.planid === plan.id &&
                    ltp.types?.some(t => t.code === locatorCode)
                )
            );
        }

        // Verificar por beneficio (CTYPE="B")
        if (benefitId) {
            const benefitExists = policy.benefits?.some(b => b.id === benefitId);
            if (!benefitExists) return false;

            const plansForBenefit = policy.plansbybenefit?.find(pb => pb.benefitid === benefitId);
            if (!plansForBenefit?.plans?.length) return false;

            return plansForBenefit.plans.some(plan =>
                (!planId || plan.id === planId) &&
                policy.locatortypesbyplan?.some(ltp =>
                    ltp.planid === plan.id &&
                    ltp.types?.some(t => t.code === locatorCode)
                )
            );
        }

        // Fallback: verificar directamente por planId
        if (planId) {
            return policy.locatortypesbyplan?.some(ltp =>
                ltp.planid === planId &&
                ltp.types?.some(t => t.code === locatorCode)
            ) ?? false;
        }

        return false;
    });
}
